/*
 * B站 - 热门榜（服务端路由）
 */
export async function fetchBilibiliHot() {
  const res = await fetch('/server-api/bilibili')
  if (!res.ok) throw new Error(`HTTP ${res.status}`)
  return res.json()
}
